import { useSyncExternalStore } from 'react';
import { getStorageUserId, subscribeStorageUserId } from '../shared/userScopedStorage';

/**
 * React hook for the current browser storage user id (signed-in user or anonymous).
 * @returns User id from Better Auth session sync, or `null` when signed out.
 */
export function useStorageUserId(): string | null {
  return useSyncExternalStore(subscribeStorageUserId, getStorageUserId, () => null);
}
